import { wrapPageElement as wrap } from '~/src/components/util/root-wrapper';
import '~/src/styles/global.css';

export const wrapPageElement = wrap;
